import React from "react";
import shuffle from "lodash/shuffle";
import SearchResultPremium from "../../../Common/SearchResultPremium";

import FeaturedBox from "./FeaturedBox";
import VendorPremium from "./VendorCaseStudiesPremiumNew";
import Pagination from "../../../Common/PaginationPremium";
import { connect } from "react-redux";
import { updateCaseStudiesReviews } from "../../../../store/actions/vendorCaseStudiesActions";
import Loader from "../../../Common/Loader";
import { withRouter } from "react-router-dom";

const caseStudyPattern = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
];

class VendorCaseStudiesPremium extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      paginationOn: 1,
      itemOnPage: 12,
      isLoader: false,
      patternForFeatured: [],
      patternForNonFeatured: [],
      routeKey: "",
    };
    this.updateState = this.updateState.bind(this);
    this.toggleLoader = this.toggleLoader.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    let shuffled = shuffle(caseStudyPattern);

    let featuredPatterns = shuffled.splice(0, 3);

    this.setState({
      patternForFeatured: featuredPatterns,
      patternForNonFeatured: shuffled,
      routeKey: this.props.location.key,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillUpdate() {
    if (this.state.routeKey !== this.props.location.key) {
      this.setState(prevState => {
        return {
          patternForNonFeatured: shuffle(prevState.patternForNonFeatured),
          routeKey: this.props.location.key,
        };
      });
    }
  }

  updateState = newValues => {
    if (this._isMounted) {
      this.setState(prevState => {
        return {
          ...prevState,
          ...newValues,
        };
      });
    }
  };

  toggleLoader = () => {
    if (this._isMounted) {
      this.setState(prevState => {
        return {
          isLoader: !prevState.isLoader,
        };
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <VendorPremium
          {...this.props}
          patterns={this.state.patternForNonFeatured}
        />
        {this.state.isLoader ? <Loader /> : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    vendorCommon: state.vendorCommon,
    vendorCaseStudies: state.vendorCaseStudies,
    vendorProfile: state.vendorProfile,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateReview: (URL, pagenumber) =>
      dispatch(updateCaseStudiesReviews(URL, pagenumber)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(VendorCaseStudiesPremium));
